module.exports = __webpack_public_path__ + "assets/illus-upload.694b9636.svg";